module.exports = __webpack_public_path__ + "img/ironing-blue.33d56419.svg";